import LegalPage from "@/components/legal/LegalPage";

const H2 = {
  color: '#f7f7f7',
  fontSize: 18,
  fontWeight: 700,
  marginTop: 24,
  marginBottom: 10,
  letterSpacing: '0.2px'
};

const H3 = {
  color: '#f7f7f7',
  fontSize: 15,
  fontWeight: 700,
  marginTop: 20,
  marginBottom: 8,
  letterSpacing: '0.2px'
};

const A = {
  color: '#C9A86A',
  textDecoration: 'underline'
};

export default function SubscriptionTerms() {
  return (
    <LegalPage title="Subscription Terms" testid="legal-subscription">
      <>
        <h2 style={H2}>Overview</h2>
        <p>These Subscription Terms explain how access, billing, upgrades, cancellations, trial periods, and subscription rules operate for CDI Collectables. They work alongside our Terms of Use, Privacy Policy, and Refund Policy. By creating an account or purchasing a plan, you agree to these Subscription Terms.</p>

        <h2 style={H2}>Billing</h2>
        <p>All fees are charged in NZD unless otherwise stated. The Basic Plan is a one-off payment that grants ongoing access to Basic features. Premium is an ongoing subscription billed monthly or annually. There is no automatic billing at the end of a trial period.</p>

        <h2 style={H2}>Subscription Plans</h2>
        <p><strong>Basic Plan (one-off payment)</strong> — Grants full access to core features permanently unless your account is closed or access is revoked for breach of Terms.</p>
        <p><strong>Premium Plan (subscription)</strong> — Provides additional enhanced features and tools. Premium can only be purchased once the Basic Plan is active.</p>

        <h2 style={H2}>Trial Periods</h2>
        <p>When you create an account, a free 3-day trial begins automatically. During the trial you have temporary access to the Service. You may choose to complete the trial period and then upgrade by purchasing the Basic Plan at any time.</p>
        <p>If you do not purchase the Basic Plan before the trial period ends, your access to the Service will automatically stop at the end of the trial. No charges are made at the end of the trial period.</p>
        <p>You may also choose to purchase the Basic Plan immediately after creating your account. Doing so overrides the trial period and grants full Basic access from the moment of purchase.</p>
        <p>Premium subscriptions are only available once the Basic Plan has been purchased.</p>

        <h2 style={H2}>Upgrades & Downgrades</h2>
        <p>You may upgrade from Basic to Premium at any time. Upgrades take effect immediately.</p>
        <p>If you downgrade from Premium back to Basic, the downgrade takes effect at the end of your current billing cycle. Your Basic access remains active because it is a one-off purchase.</p>

        <h2 style={H2}>Automatic Renewal (Premium Only)</h2>
        <p>Premium subscriptions renew automatically at the end of each billing cycle. You may cancel at any time. Cancellation stops future Premium charges but does not refund past charges. Your Basic access remains active after Premium cancellation.</p>

        <h2 style={H2}>Cancellation</h2>
        <p>You can cancel Premium at any time from your account settings. Cancellation prevents future Premium billing. You retain Premium access until the end of the current billing period. Your Basic access remains active permanently.</p>

        <h2 style={H2}>Payment Failures (Premium Only)</h2>
        <p>If a Premium payment fails, we may retry the charge. Premium features may be paused until payment is successful. If payment cannot be completed, Premium access may be terminated. Your Basic access remains active.</p>

        <h2 style={H2}>Fee Changes</h2>
        <p>If Premium subscription fees change, you will receive at least 30 days’ notice. If you do not wish to continue at the new price, you may cancel before the change takes effect.</p>

        <h2 style={H2}>Third-Party Features</h2>
        <p>Some features rely on third-party providers. If a provider discontinues or changes a feature, access may be removed without refund.</p>

        <h2 style={H2}>Account Requirements</h2>
        <p>You must maintain an active CDI Collectables account to use Basic or Premium features. Sharing accounts or subscription access is not permitted.</p>

        <h2 style={H2}>Refunds</h2>
        <p>Refunds are governed by our Refund Policy. Basic Plan payments and Premium subscription fees are generally non-refundable once access has been granted or a billing cycle has begun.</p>

        <h2 style={H2}>Contact</h2>
        <p>For subscription questions, email: <a style={A} href="mailto:support@cdicollectables.co.nz">support@cdicollectables.co.nz</a></p>
      </>
    </LegalPage>
  );
}
